import { cn } from "@/lib/utils";

interface CheckboxGroupProps {
  options: readonly { value: string; label: string }[];
  selected: string[];
  onChange: (values: string[]) => void;
  disabled?: boolean;
}

/** Inline wrap of checkbox chips over a small fixed set of options. */
export function CheckboxGroup({
  options,
  selected,
  onChange,
  disabled,
}: CheckboxGroupProps) {
  const toggle = (value: string) => {
    onChange(
      selected.includes(value)
        ? selected.filter((v) => v !== value)
        : [...selected, value]
    );
  };

  return (
    <div className="flex flex-wrap gap-2">
      {options.map((opt) => {
        const active = selected.includes(opt.value);
        return (
          <label
            key={opt.value}
            className={cn(
              "flex cursor-pointer items-center gap-2 rounded-md border px-3 py-1.5 text-sm",
              active
                ? "border-primary bg-primary/5 text-foreground"
                : "border-input text-muted-foreground",
              disabled && "cursor-not-allowed opacity-50"
            )}
          >
            <input
              type="checkbox"
              className="h-4 w-4"
              checked={active}
              onChange={() => toggle(opt.value)}
              disabled={disabled}
            />
            {opt.label}
          </label>
        );
      })}
    </div>
  );
}
